/* eslint-disable react-hooks/exhaustive-deps */
import { Select } from 'antd';
import { connect } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { Widget } from 'datastake-daf/dist/components';
import { icons } from './config';
import EmptyState from './emptyState';
import { getPopupContainer } from '../../../../../../../helpers/popUp';
import { actions } from '../../../../../../../store/reducers/dashboard';
import Chart from '../../../../../../../components/dashboards/Widgets/SubjectDataConsolidation';

const SubjectDataConsolidation = ({
  t = (s) => s,
  sidebarCollapsed = false,
  data,
  PmeProjectGetWithFilters,
  retrived = false,
  selectedProjectAndLanguage,
  filterKey,
}) => {
  const [filter, setFilter] = useState('mineSite');

  useEffect(() => {
    if (filterKey === '1a') {
      setFilter('mineSite');
    }
    if (filterKey === '2a') {
      setFilter('supplyChainActor');
    }
  }, [filterKey]);

  useEffect(() => {
    PmeProjectGetWithFilters({
      filters: {
        subject: filter,
      },
      widget: 'subjectDataConsolidation',
    });
  }, [filter, PmeProjectGetWithFilters, selectedProjectAndLanguage])

  const isEmpty = (Array.isArray(data) ? !data.length : false);

  return (
    <Widget
      className="no-pb-header"
      title={t('Data Consolidation')}
      addedHeader={(
        <>
          <div className="flex-1" />
          <div>
            <Select
              value={filter}
              style={{ minWidth: 200, maxWidth: 330 }}
              onChange={(val) => setFilter(val)}
              {...getPopupContainer()}
              disabled={!retrived}
              className='custom-select white'
            >
              <Select.Option value="mineSite">
                <div className="flex-row">
                  <div className="mr-1">
                    {icons.mineSite}
                  </div>
                  <span className="ellipsis-text">
                    {t('Mine Sites')}
                  </span>
                </div>
              </Select.Option>
              <Select.Option value="location">
                <div className="flex-row">
                  <div className="mr-1">
                    {icons.location}
                  </div>
                  <span className="ellipsis-text">
                    {t('All Locations')}
                  </span>
                </div>
              </Select.Option>
              <Select.Option value="supplyChainActor">
                <div className="flex-row">
                  <div className="mr-1">
                    {icons.supplyChainActor}
                  </div>
                  <span className="ellipsis-text">
                    {t('Supply Chain Actors')}
                  </span>
                </div>
              </Select.Option>
              <Select.Option value="stakeholder">
                <div className="flex-row">
                  <div className="mr-1">
                    {icons.stakeholder}
                  </div>
                  <span className="ellipsis-text">
                    {t('All Stakeholders')}
                  </span>
                </div>
              </Select.Option>
            </Select>
          </div>
        </>
      )}
    >
      {isEmpty ?
        <EmptyState t={t} />
        : (
          <Chart
            noBorders
            data={data}
            filter={filter}
            resizeTrigger={sidebarCollapsed}
            t={t}
          />
        )}
    </Widget>
  );
}

export default connect(() => ({}), { ...actions })(SubjectDataConsolidation);
